import React, { useState } from "react";
import "../../style/testDetails.css";

import ConstUtils from "../../config/constants";

export default function TestDetails(props) {
    const { testList, specialInstructionsList } = props.caseData;

    const [isExpanded, setIsExpanded] = useState(false);
    const [listSize, setListSize] = useState(window.innerWidth > 576 ? 4 : 3);

    const toggleExpand = () => {
        window.scrollTo({ behavior: "smooth" });
        setIsExpanded(!isExpanded);
    };

    const getSpecialInstructionsArr = () => {
        let specialInstructionsArr = [];
        if (specialInstructionsList && specialInstructionsList.length) {
            specialInstructionsList.map((test) => {
                const instructions = test.split("|");
                instructions.map((instruction) => {
                    if (instruction) {
                        specialInstructionsArr.push(instruction.trim());
                    }
                    return "";
                });
                return "";
            });
        }
        return specialInstructionsArr;
    };

    return (
        <>
            <div className="test-guide-lines">
                <div className="test-details-header">
                    <div className="test-guide-lines-header">
                        <img src={`${ConstUtils.StaticS3ImageUrl}/Note.svg`} alt="" />
                        <span>TEST GUIDELINES</span>
                    </div>
                    <img
                        style={{ height: "20px" }}
                        src={`${ConstUtils.StaticS3ImageUrl}/MustReadV1.svg`}
                        alt=""
                    />
                </div>
                <div className="test-guide-lines-body">
                    {getSpecialInstructionsArr().length ? (
                        <>
                            {isExpanded
                                ? getSpecialInstructionsArr()?.map((test, index) => (
                                    <li key={index}>{test}</li>
                                ))
                                : getSpecialInstructionsArr()
                                    ?.slice(0, listSize)
                                    .map((test, index) => <li key={index}>{test}</li>)}
                        </>
                    ) : (
                        <>
                            <li>No Smoking</li>
                            <li>No Drinking</li>
                        </>
                    )}
                </div>
            </div>

            <div className="test-divider"></div>

            <div className="medical-tests">
                <div className="test-guide-lines-header">
                    <img
                        src={`${ConstUtils.StaticS3ImageUrl}/CenterVisit.svg`}
                        style={{ height: "25px" }}
                        alt=""
                    />
                    <span>MEDICAL TESTS</span>
                </div>

                <div className="test-guide-lines-body">
                    {isExpanded
                        ? testList?.map((test, index) => <li key={index}>{test}</li>)
                        : testList
                            ?.slice(0, listSize)
                            .map((test, index) => <li key={index}>{test}</li>)}
                </div>

                {(testList?.length > listSize || getSpecialInstructionsArr().length > listSize) && (
                    <div className="test-guide-lines-footer">
                        <button onClick={toggleExpand}>
                            {isExpanded ? "Collapse" : "View All"}
                        </button>
                        <img
                            src={
                                isExpanded
                                    ? `${ConstUtils.StaticS3ImageUrl}/UpArrow.svg`
                                    : `${ConstUtils.StaticS3ImageUrl}/DownArrow.svg`
                            }
                            style={{ cursor: "pointer" }}
                            onClick={toggleExpand}
                            alt=""
                        />
                    </div>
                )}
            </div>
        </>
    );
}